import { createStore, createLogger } from 'vuex';

// 利用glob自动化导入modules目录下的路由配置
const modules:Record<string, any> = {};
const modulesContext = import.meta.globEager('./modules/*.ts');
for (const path in modulesContext)
{
    modules[path.slice(10, -3)] = modulesContext[path].default;
}

const state = ():IRootStoreState => ({
    title: import.meta.env.VITE_APP_TITLE as string, // 默认页面标题
    selRouteName: '',
    currentBannerHeight: 0, // 当前页面的 Banner 高度，用于动态切换导航栏状态
    routerActionType: '' // 当前路由切换的类型，forward=前进、back=回退
});

const getters = {

};

const actions = {};

const mutations = {
    setTitle(state:IRootStoreState, title:string)
    {
        state.title = title;
    },
    setSelRouteName(state:IRootStoreState, name:string)
    {
        state.selRouteName = name;
    },
    setCurrentBannerHeight(state:IRootStoreState, value:number)
    {
        state.currentBannerHeight = value;
    },
    updateRouterActionType(state:IRootStoreState, type: 'forward'|'back')
    {
        state.routerActionType = type;
    }
};

export default createStore({
    modules: modules,
    strict: !import.meta.env.PROD,
    plugins: !import.meta.env.PROD ? [createLogger()] : [],
    state,
    getters,
    actions,
    mutations
});
